import React from 'react';

//redux
import { useSelector } from 'react-redux';

const FooterCopyright  = () => {
  const brand = useSelector((state: any) => state.brand);

  return (
    <React.Fragment>
        {new Date().getFullYear()} © {brand.name}
    </React.Fragment>
  );
};

export default FooterCopyright ;
